import { styled } from 'styled-components'

export const Wrapper = styled.div<{ $height?: number }>`
  height: ${({ $height }) => ($height ? `${$height}px` : '300px')};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
